import React, { Fragment } from 'react';
import { Integer, DecimalRounded } from '../../../utils/NumeralParts';
import Formatters from '../../../features/shared/utils/Formatters'
import ContentLoader from 'react-content-loader';

export default class LoanOfferPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  get hasSubscriptionFee() {
    const {
      loanOffer: {
        custom_fields: { service_fee_amount: serviceFeeAmount } = {},
      },
    } = this.props;

    return serviceFeeAmount === 0;
  }

  get convenienceFeeAmount() {
    const {
      loanOffer: {
        custom_fields: { service_fee_amount: serviceFeeAmount } = {},
      },
      selectedOption,
    } = this.props;
    const calculatedServiceFeeAmount = this.hasSubscriptionFee
      ? selectedOption.principal_amount * (1.99 / 100)
      : serviceFeeAmount;

    return calculatedServiceFeeAmount;
  }

  get disbursedAmount() {
    const {
      loanOffer: { custom_fields: { disbursed_amount: disbursedAmount } = {} },
      selectedOption: option,
    } = this.props;
    const { principal_amount } = option;
    const disbursed_amount =
      disbursedAmount === 0 ? principal_amount : disbursedAmount;
    return Math.round(disbursed_amount);
  }

  get interestAmount() {
    const { selectedOption } = this.props;
    const convenienceFeeAmount = this.hasSubscriptionFee
      ? 0.0
      : this.convenienceFeeAmount;
    const interest =
      selectedOption.total - this.disbursedAmount - convenienceFeeAmount;

    return Formatters.currencyDecimal(interest);
  }

  onClickBreakdown = (e) => {
    e.preventDefault();
    this.props.toggleBreakdown();
  };

  onClickNext = (e) => {
    e.preventDefault();
    this.props.onClickNext();
  };

  renderFrequency = () => {
    let { selectedOption: option } = this.props;
    let mode = option.frequency_mode;
    if (option.frequency >= 2) {
      mode = `${option.frequency} ${option.frequency_mode}s`;
    }
    const frequency =
      mode === 'single_payment' ? 'in a single repayment' : `every ${mode}`;
    return frequency;
  };

  renderDuration = () => {
    let { selectedOption: option, loanOffer } = this.props;
    let term = option.term_mode || 'month';
    let term_length =
      option.term_length === 0
        ? loanOffer.custom_fields.term_length
        : option.term_length;
    if (term_length > 1) {
      term = `${term}s`;
    }
    return `${term_length} ${term}`;
  };

  renderPaymentCount = () => {
    let { selectedOption } = this.props;
    let copy = 'payment';
    const paymentsCount = selectedOption.payment_schedules.length;
    if (this.isBullet()) copy = `${copy}s`;
    return `${paymentsCount} ${copy}`;
  };

  isBullet = () => {
    const { selectedOption } = this.props;
    return selectedOption.payment_schedules.length > 1;
  };

  renderPayable = () => {
    return (
      <section className='cardSection _borderBottom_unset'>
        <p className='_textAlign_center subhead -primary'>You will pay</p>
        {!this.isLoading && this.renderPayableAmount()}
      </section>
    );
  };

  renderPayableAmount = () => {
    const { selectedOption } = this.props;
    const firstSchedule = selectedOption.payment_schedules[0];
    return (
      <Fragment>
        <div className='_displayFlex _justifyContent-center _alignItems-center'>
          <span className='-primary _marginRight--large _marginBottom--small emphasize'>
            ₱
          </span>
          <h2
            className='headline -primary _fontSize--xxlarge'
            data-testid='loan-offer-preview-payment-per-frequency-whole'
          >
            {Integer(firstSchedule.total)}
          </h2>
          <span
            className='-primary _alignSelf-center emphasize'
            data-testid='loan-offer-preview-payment-per-frequency-decimal'
          >
            {`${DecimalRounded({ number: firstSchedule.total })}`}
          </span>
          <i
            data-testid='toggle-breakdown-button'
            className='materialIcon -primary --small _marginLeft--normal _marginBottom--normal'
            onClick={this.onClickBreakdown}
          >
            {this.props.isBreakdownVisible
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_up'}
          </i>
        </div>
        <p
          className='subhead _textAlign_center _marginTop--none _marginBottom--small'
          data-testid='loan-offer-preview-frequency'
        >
          {this.renderFrequency()}
        </p>
      </Fragment>
    );
  };

  renderPreview = () => {
    const style = !this.props.isBreakdownVisible
      ? { borderRadius: 'unset' }
      : {};
    return (
      <div
        class='ds-card _margin--none'
        data-testid='loan-offer-preview-container'
        style={style}
      >
        {this.renderPayable()}
        {this.renderBreakdown()}
      </div>
    );
  };

  renderLoading = () => {
    const { isBreakdownVisible } = this.props;
    const style = isBreakdownVisible ? { borderRadius: 'unset' } : {};
    return (
      <div
        class='ds-card _margin--none'
        data-testid='loan-offer-preview-container'
        style={style}
      >
        {this.renderPayable()}
        {this.renderContentLoader()}
      </div>
    );
  };

  renderInterest() {
    const { selectedOption } = this.props;
    return `${Formatters.currencyDecimal(selectedOption.equivalent_aor, false)}%/mo.`;
  }

  renderBreakdown = () => {
    const { selectedOption } = this.props;

    const style = { display: this.props.isBreakdownVisible ? 'block' : 'none' };

    return (
      <div className='' style={style}>
        <div className='_padding--large _paddingTop--xxsmall _paddingBottom--none'>
          <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
            <p className='subhead _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Interest Rate
            </p>
            <p
              className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              data-testid='loan-offer-preview-interest-rate'
            >
              {this.renderInterest()}
            </p>
          </div>
          <div className='_displayFlex _justifyContent-space-between'>
            <p className='subhead _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Loan Duration
            </p>
            <p
              className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              data-testid='loan-offer-preview-duration'
            >
              {this.renderDuration()}
            </p>
          </div>
          <div className='_displayFlex _justifyContent-space-between'>
            <p className='subhead _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Number of Payments
            </p>
            <p
              className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              data-testid='loan-offer-preview-payment-count'
            >
              {this.renderPaymentCount()}
            </p>
          </div>
          <div className='_displayFlex _justifyContent-space-between _alignItems-baseline'>
            <p className='subhead _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Total You Will Pay
            </p>
            <p
              className='_fontSize--normal-mobileOnly _displayFlex _alignItems-center _whiteSpace_nowrap'
            >
              <span data-testid='loan-offer-preview-total-payable-amount'>
                ₱ {Formatters.currencyDecimal(selectedOption.total)}
              </span>
            </p>
          </div>
        </div>

        <div
          className='_backgroundColor-sh050 _padding--large _paddingTop--none _paddingBottom--normal'
          style={style}
        >
          <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
            <p className='-darkBlue _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Amount You Will Receive
            </p>
            <p
              className='-darkBlue _fontSize--normal-mobileOnly _whiteSpace_nowrap'
              data-testid='loan-offer-preview-breakdown-disbursed-amount'
            >
              ₱ {Formatters.currencyDecimal(this.disbursedAmount)}
            </p>
          </div>
          <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
            <p className='-secondary _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              + Convenience Fee
            </p>
            {this.renderConvenienceFee()}
          </div>
          <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
            <p className='-secondary _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              + Interest (
              {`${Formatters.currencyDecimal(selectedOption.equivalent_aor, false)}%/mo`}
              )
            </p>
            <p
              className='_fontSize--normal-mobileOnly -secondary _whiteSpace_nowrap'
              data-testid='loan-offer-preview-breakdown-interest-amount'
            >
              + {Formatters.currencyDecimal(this.interestAmount)}
            </p>
          </div>
          <div
            className='_marginTop--small'
            style={{ height: '1px', backgroundColor: '#CDCEE7' }}
          ></div>
          <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
            <p className='-darkBlue _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
              Total You Will Pay
            </p>
            <p
              className='-darkBlue _fontSize--normal-mobileOnly _whiteSpace_nowrap'
              data-testid='loan-offer-preview-breakdown-total-payable-amount'
            >
              = ₱ {Formatters.currencyDecimal(selectedOption.total)}
            </p>
          </div>
        </div>
      </div>
    );
  };

  renderConvenienceFee = () => {
    let labelStyle = { textDecoration: 'line-through' };
    const calculatedConvenienceFeeAmount = this.convenienceFeeAmount;

    return (
      <p
        className='_fontSize--normal-mobileOnly -secondary _whiteSpace_nowrap'
        data-testid='loan-offer-preview-breakdown-convenience-fee-amount'
      >
        <span style={this.hasSubscriptionFee ? labelStyle : {}}>
          + {Formatters.currencyDecimal(calculatedConvenienceFeeAmount)}
        </span>
        {this.hasSubscriptionFee && <span> 0.00</span>}
      </p>
    );
  };
  renderContentLoader = () => {
    return (
      <ContentLoader
        height={88}
        width={384}
        speed={2}
        primaryColor='#f3f3f3'
        secondaryColor='#b2c9e0'
      >
        <rect x='85' y='0' ry='0' width='214' height='36' />
        <rect x='120' y='50' rx='0' ry='0' width='144' height='20' />
      </ContentLoader>
    );
  };

  get isLoading() {
    const { loading, selectedOption, loanOffer } = this.props;
    return !selectedOption || !loanOffer || (loading && selectedOption);
  }

  get label() {
    if (this.isLoading || this.props.loadingBtn) return 'Loading...';
    return 'Next';
  }

  render() {
    const style = {
      borderBottom: 'unset',
      position: 'fixed',
      bottom: 0,
      width: '100%',
      marginBottom: '68px',
      zIndex: 777,
    };

    return (
      <div
        className='cardSection _padding--none _paddingLeft--small _paddingRight--small'
        style={style}
      >
        <div style={{ boxShadow: '0 0 3px 3px rgba(0,0,0,0.07)' }}>
          {!this.isLoading && this.renderPreview()}
          {this.isLoading && this.renderLoading()}
          <button
            data-testid='loan-offer-preview-next-button'
            disabled={this.isLoading || this.props.loadingBtn}
            onClick={this.onClickNext}
            className='ds-btn --full'
          >
            {this.label}
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanOfferMobilePreview.js